import {techDocWebsocketCommands} from '../../constants/techDocWebsocketCommands';
import {domains} from '../../constants/Utils';
import {sparePartsWebsocketCommands} from '../../constants/sparePartsWebsocketCommands';

export const fetchAnsweringSchemaListPageData = (domain, pageSize, sorted, cursor, isNextFromPivot, filtered) => dispatch => {
    switch (domain) {
        case domains.TECHNICAL_DOCUMENTATION: {
            dispatch({
                type: techDocWebsocketCommands.TECH_DOC_ANSWERING_SCHEMA_LIST_FETCH_PENDING,
                techDocWebsocket: true,
                command: techDocWebsocketCommands.TECH_DOC_ANSWERING_SCHEMA_LIST,
                payload: {pageSize: pageSize, sorted: sorted, cursor: cursor, isNextFromPivot: isNextFromPivot, filtered: filtered}
            });
            break;
        }
        case domains.SPARE_PARTS: {
            dispatch({
                type: sparePartsWebsocketCommands.SPARE_PARTS_ANSWERING_SCHEMA_LIST_FETCH_PENDING,
                sparePartsWebsocket: true,
                command: sparePartsWebsocketCommands.SPARE_PARTS_ANSWERING_SCHEMA_LIST,
                payload: {pageSize: pageSize, sorted: sorted, cursor: cursor, isNextFromPivot: isNextFromPivot, filtered: filtered}
            });
            break;
        }
    }
};


export const deleteAnsweringSchemaListRow = (domain, id, formType) => dispatch => {
    switch (domain) {
        case domains.TECHNICAL_DOCUMENTATION: {
            dispatch({
                type: techDocWebsocketCommands.TECH_DOC_ANSWERING_SCHEMA_DELETE_PENDING,
                techDocWebsocket: true,
                command: techDocWebsocketCommands.TECH_DOC_ANSWERING_SCHEMA_DELETE,
                payload: {
                    payload:{
                        id: id,
                        answeringSchema: {
                            formType: formType
                        }
                    }
                }
            });
            break;
        }
        case domains.SPARE_PARTS: {
            dispatch({
                type: sparePartsWebsocketCommands.SPARE_PARTS_ANSWERING_SCHEMA_DELETE_PENDING,
                sparePartsWebsocket: true,
                command: sparePartsWebsocketCommands.SPARE_PARTS_ANSWERING_SCHEMA_DELETE,
                payload: {
                    payload:{
                        id: id,
                        answeringSchema: {
                            formType: formType
                        }
                    }
                }
            });
            break;
        }
    }
};
